// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @media (min-width: 992px) {
  .layout-dashboard .ant-layout-footer {
    margin: 20px 0 20px 20px;
  }
  .layout-dashboard .ant-layout-sider.sider-primary {
    height: calc(100vh - 0px);
  }
  .layout-dashboard .ant-layout {
    width: auto;
    flex-shrink: 1;
  }
  .ant-layout-margin-left-true {
    margin-left: 280px;
    transition: margin-left 0.2s ease;
  }
  .ant-layout-margin-left-false {
    margin-left: 80px;
    transition: margin-left 0.2s ease;
  }
  .layout-dashboard .header-control .sidebar-toggler {
    display: none;
  }
} */

/* @media (min-width: 768px) {
  .layout-dashboard .ant-layout-header {
  }
  .layout-dashboard .header-control {
    margin-top: 0;
  }
  .layout-dashboard .header-control .header-search {
    margin: 0 7px;
  }
  .layout-dashboard .header-control .btn-sign-in span {
    display: inline;
  }
  .profile-nav-bg {
    margin-top: -87.8px;
  }
  .card-profile-head {
    margin: -53px 24px 24px;
  }
  .ant-layout-margin-left-true {
    margin-left: 300px;
    transition: margin-left 0.2s ease;
  }
  .ant-layout-margin-left-false {
    margin-left: 80px;
    transition: margin-left 0.2s ease;
  }
} */

/* @media (min-width: 992px) {
  .card-billing-info.ant-card .ant-card-body {
    display: flex;
  }
  .layout-dashboard-rtl {
    overflow: auto;
  }
  .layout-dashboard-rtl .ant-layout-sider.sider-primary {
    margin: 20px 20px 0 0;
    height: calc(100vh - 20px);
  }
  .layout-dashboard-rtl .ant-layout-sider.sider-primary {
    right: 0;
    left: auto;
  }
  .layout-dashboard-rtl .ant-layout-sider.sider-primary {
    right: 0;
    left: auto;
  }
  .layout-dashboard-rtl .ant-layout {
    margin-right: 270px;
    margin-left: 0;
  }
  .layout-dashboard-rtl .ant-layout-footer {
    margin: 0 20px 20px 0;
  }
} */

/* @media (max-width: 768px) {
  .ant-card.criclebox {
    width: 100%;
  }
  .card-row {
    display: block !important;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/assets/styles/responsive.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;GAsBG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH;;;;;;;GAOG","sourcesContent":["/* @media (min-width: 992px) {\n  .layout-dashboard .ant-layout-footer {\n    margin: 20px 0 20px 20px;\n  }\n  .layout-dashboard .ant-layout-sider.sider-primary {\n    height: calc(100vh - 0px);\n  }\n  .layout-dashboard .ant-layout {\n    width: auto;\n    flex-shrink: 1;\n  }\n  .ant-layout-margin-left-true {\n    margin-left: 280px;\n    transition: margin-left 0.2s ease;\n  }\n  .ant-layout-margin-left-false {\n    margin-left: 80px;\n    transition: margin-left 0.2s ease;\n  }\n  .layout-dashboard .header-control .sidebar-toggler {\n    display: none;\n  }\n} */\n\n/* @media (min-width: 768px) {\n  .layout-dashboard .ant-layout-header {\n  }\n  .layout-dashboard .header-control {\n    margin-top: 0;\n  }\n  .layout-dashboard .header-control .header-search {\n    margin: 0 7px;\n  }\n  .layout-dashboard .header-control .btn-sign-in span {\n    display: inline;\n  }\n  .profile-nav-bg {\n    margin-top: -87.8px;\n  }\n  .card-profile-head {\n    margin: -53px 24px 24px;\n  }\n  .ant-layout-margin-left-true {\n    margin-left: 300px;\n    transition: margin-left 0.2s ease;\n  }\n  .ant-layout-margin-left-false {\n    margin-left: 80px;\n    transition: margin-left 0.2s ease;\n  }\n} */\n\n/* @media (min-width: 992px) {\n  .card-billing-info.ant-card .ant-card-body {\n    display: flex;\n  }\n  .layout-dashboard-rtl {\n    overflow: auto;\n  }\n  .layout-dashboard-rtl .ant-layout-sider.sider-primary {\n    margin: 20px 20px 0 0;\n    height: calc(100vh - 20px);\n  }\n  .layout-dashboard-rtl .ant-layout-sider.sider-primary {\n    right: 0;\n    left: auto;\n  }\n  .layout-dashboard-rtl .ant-layout-sider.sider-primary {\n    right: 0;\n    left: auto;\n  }\n  .layout-dashboard-rtl .ant-layout {\n    margin-right: 270px;\n    margin-left: 0;\n  }\n  .layout-dashboard-rtl .ant-layout-footer {\n    margin: 0 20px 20px 0;\n  }\n} */\n\n/* @media (max-width: 768px) {\n  .ant-card.criclebox {\n    width: 100%;\n  }\n  .card-row {\n    display: block !important;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
